// src/app/chat/error.tsx
'use client';
export default function Error() {
  return <div>出错了，请稍后重试。</div>;
}